import React from "react";
import {VeterinarioObject} from "../../models/Veterinario";

export const cardSubtitle = (i: VeterinarioObject) => (
  <>{i.tipo}</>
);

export const cardTitle = (i: VeterinarioObject) => (
  <>{i.nome}</>
);

export const cardContent = (i: VeterinarioObject) => (
  <>
      <div>{i.cidade} ({i.estado})</div>
      {
        i.email &&
        <div>
          {i.email}
        </div>
      }

      {
        i.telefone && <div>{i.telefone}</div>
      }
    </>
);
